import React from "react";
import styled from "styled-components";

const SupportChatMessage = ({ message }) => (
  <MessageContainer isMine={message.recipientId !== "4459"}>
    {message.type === "text" ? (
      <MessageText>{message.message}</MessageText>
    ) : message.type === "image" ? (
      <MessageImage src={message.media.source} />
    ) : null}
  </MessageContainer>
);

const MessageContainer = styled.div`
  padding: 5px 0;
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: ${props => (props.isMine ? "flex-start" : "flex-end")};
  color: ${props => (props.isMine ? "black" : "grey")};
`;

const MessageText = styled.div`
  font-size: 10pt;
  text-align: left;
  width: inherit;
  padding: 10px;
  border-radius: 5px;
  max-width: 60%;
  background-color: white;

  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
  width: auto;
`;

const MessageImage = styled.img`
  max-width: 60%;
  max-height: 200px;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
`;

export default SupportChatMessage;



// WEBPACK FOOTER //
// ./src/containers/SupportChat/SupportChatMessage.js